import ResumeProfileProjectBullets from './ResumeProfileProjectBullets'

export default ResumeProfileProjectBullets
